<template>
    <div>
        <div class="row my-5">
            <div class="col-12">
                <b-skeleton animation="fade" width="200px" height="11px"/>
                <b-skeleton animation="fade" :width="isTablet ? '50%': isMobile ? '100%' : '300px'" height="19px" />
            </div>
        </div>
        <div class="row justify-content-center mb-5 px-md-5">
            <div :class="['col-12 col-md-6 col-lg-4 d-none', {'d-block': index==1, 'd-lg-block': index>=2, 'd-md-block': index<3}]" v-for="index in 3" :key="index">
                <b-card class="shadowed">
                    <b-skeleton type="button" animation="fade" class="ml-auto mb-3" />
                    <b-skeleton-img animation="fade" height="120px" no-aspect />
                    <b-skeleton animation="fade" height="19px" width="100%" class="my-3" />
                    <b-skeleton animation="fade" height="19px" width="50%" v-if="isTablet" />
                    <div class="ml-auto d-flex justify-content-end align-items-center">
                        <b-skeleton animation="fade" height="11px" width="60px" />
                        <b-skeleton type="button" animation="fade" class="ml-2" />
                    </div>
                </b-card>
            </div>
        </div>
        <div class="row justify-content-center mb-5 px-md-5">
            <div :class="['col-12 col-md-6', {'d-none d-md-block': index==2}]" v-for="index in 2" :key="index">
                <b-card class="shadowed">
                    <div class="ml-auto w-50">
                        <b-skeleton-img animation="fade" :height="isMobile ? '64px' : '120px'" width="100%" no-aspect />
                    </div>
                    <b-skeleton animation="fade" height="19px" width="300px" class="my-3 mw-100" /> 
                    <b-skeleton animation="fade" height="14px" width="100%" />
                    <b-skeleton animation="fade" height="14px" width="100%" />
                    <b-skeleton animation="fade" height="14px" width="100%" />
                    <b-skeleton animation="fade" height="14px" width="100%" v-if="isMobile" />
                    <b-skeleton animation="fade" height="14px" width="100%" v-if="isMobile" />
                    <ul class="list-unstyled mt-3">
                        <li class="d-flex justify-content-start align-items-center">
                            <b-skeleton-icon icon="square-fill" animation="fade" />
                            <b-skeleton animation="fade" height="11px" width="60px" class="ml-2" /> 
                        </li>
                        <li class="d-flex justify-content-start align-items-center">
                            <b-skeleton-icon icon="square-fill" animation="fade" />
                            <b-skeleton animation="fade" height="11px" width="115px" class="ml-2" /> 
                        </li>
                    </ul>
                    <b-skeleton type="button" animation="fade" class="ml-auto" />
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
    import mobileCheckMixin from "../../mixins/mobileCheckMixin";

    export default {
        name: "ServiceListSkeleton",
        mixins: [mobileCheckMixin]
    }
</script>